(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-game-demo"] && !Shopify.designMode) return;
  try {
    
  function loadProductDemos() {
    document.querySelectorAll('[data-demo-script]').forEach((host) => {
      if (host.dataset.observed) return;
      host.dataset.observed = 'true';
      const load = () => {
        if (customElements.get('boom-demo') || document.querySelector('script[data-bm-demo]')) return;
        const script = document.createElement('script');
        script.src = host.dataset.demoScript;
        script.dataset.bmDemo = 'true';
        script.async = true;
        script.onerror = () => { script.remove(); host.dataset.observed = ''; };
        document.head.append(script);
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) { observer.disconnect(); load(); }
      }, { rootMargin: '300px' });
      observer.observe(host);
    });
  }
  loadProductDemos();
  document.addEventListener('shopify:section:load', loadProductDemos);

  } catch(e) { console.error(e); }
})();
})();
